//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  faThumbsUp,
  faExclamationCircle,
  faExclamationTriangle,
  faInfo,
} from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'base-toast-notification-item',
  props: {
    notification: {},
  },
  computed: {
    notificationIcon() {
      if (this.notification.icon) {
        return (this.notification.iconPrefix || '') + this.notification.icon;
      }

      switch (this.notification.level) {
        case 'success':
          return faThumbsUp;
        case 'warning':
          return faExclamationCircle;
        case 'danger':
          return faExclamationTriangle;
        default:
          return faInfo;
      }
    },
  },
  filters: {
    capitalize: function (value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  methods: {
    clearMessage(id) {
      this.$emit('clearMessage', id);
    },
  },
};
